import { Heading, SidePanelSlots } from '@dreryk/react-components';

import { visitPatientPregnancyStatusTranslationKeys } from '../../../translations';

type GynecologicalInterviewRegularInterviewCategoryContentProps = {
   readonly description: string | undefined;
};

export const GynecologicalInterviewRegularInterviewCategoryContent = (
   props: GynecologicalInterviewRegularInterviewCategoryContentProps
): JSX.Element => {
   return (
      <div>
         <Heading
            testId={'regularInterview'}
            content={visitPatientPregnancyStatusTranslationKeys.gynecologicalInterview}
            type={'h3'}
            bold
         />
         {props.description ? <SidePanelSlots.Expandable>{props.description}</SidePanelSlots.Expandable> : null}
      </div>
   );
};
